{
  "getInTouch": "Get in Touch",
  "contactIntro": "Have a question or want to get in touch? Fill out the form below or email us directly at <supportLink>{{email}}</supportLink>",
  "poweredBy": "Powered by <holigralLink>Holigral</holigralLink>",
  "terms": "Terms",
  "privacy": "Privacy",
  "contact": "Contact",
  "intro": "Intro",
  "getStarted": "Get started",
  "home": {
    "hero": {
      "sub": "See your people clearly.",
      "title": "Understand how your people actually operate.",
      "bullets": "Strengths • Working style • Fit • Complement",
      "one": "One profile."
    },
    "pain": "You can measure what someone knows and what they’ve done, but the thing that actually decides whether they thrive, fit, and last has always been invisible.",
    "steps": {
      "people": {
        "title": "It starts with the people you already have.",
        "body": "Profile your current team and you’ll see them described in a way you’ve never been able to express, confirming what you sensed and surfacing what you didn’t. Real gains in the team you already run."
      },
      "works": {
        "title": "You see how each person actually works.",
        "body": "Not what they know, but how they operate. Where their energy flows naturally, where it costs them effort, the conditions and the kind of role in which they do their best work."
      },
      "fits": {
        "title": "You see how the whole team fits together.",
        "body": "The combinations that quietly multiply each other, the gaps nobody had mapped, and the friction that was never a personality clash, just a mismatch no one had the language to name. Arrange the whole around how each part actually works."
      },
      "decisions": {
        "title": "Then, the decisions you can’t get wrong.",
        "body": "Every hire is a long commitment made on a CV and an interview, the two things that look away from how a person will actually fit, work, and last. Whatever the role, whatever the salary, make that call with your eyes open."
      }
    },
    "closing": {
      "title": "There’s a real method underneath all of this.",
      "body": "Most ways of sizing people up reach for what’s easy to measure and miss what matters most: not what someone knows, but how their nature meets the work in front of them. Pam Saunders spent decades working out how people actually operate, why one person flourishes where another quietly strains, why some combinations multiply and others grind. The theory developed by this work reveals the underlying pattern of each of us, and that in turn shows how we operate and interact most effectively.",
      "attribution": "Pam Saunders, inventor of the Holigral Method"
    },
    "cta": {
      "text": "Set up a workspace and explore sample profiles. No card, no call, no commitment.",
      "button": "Get Started"
    }
  }
}
